module.exports = __webpack_public_path__ + "media/customizations/harvestlife/back-bc4d5f42bb37429989143faf8440765d.jpg";